var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUideck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 52,
    viewBox: "0 0 200 52",
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 38.8079,
    x2: 8.58038,
    y1: 46.5383,
    y2: -5.02959
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2535c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169697,
    stopColor: "#36409b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575758,
    stopColor: "#475bc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7075e4"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 60.5417,
    x2: 60.5417,
    y1: 0,
    y2: 51.0085
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#375ad8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472727,
    stopColor: "#3c56dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a1a8f"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 30.6663,
    x2: 30.6663,
    y1: 0,
    y2: 51.518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#233593"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472727,
    stopColor: "#4957d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890909,
    stopColor: "#5465ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a67ff"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 4.28592,
    x2: 11.4261,
    y1: 8.72853,
    y2: -0.208004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a4a9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327273,
    stopColor: "#475bc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7090e4"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 60.8992,
    x2: 53.9964,
    y1: 42.9276,
    y2: 51.1328
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193939,
    stopColor: "#3f2bb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c38ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m184.095 31.7551 15.808-19.0639h-7.76l-14.174 17.0891v-.1095l-6.422 7.7869-1.398 1.6943c-.04.0675-.078.1368-.12.2043l-2.408 2.903c-.446.4055-.918.7822-1.416 1.1234-2.112 1.447-4.637 2.2881-7.382 2.2889v.0992c-1.827-.0032-3.552-.3772-5.126-1.0523-2.366-1.0166-4.389-2.7209-5.814-4.8626-1.424-2.1452-2.254-4.7088-2.255-7.497 0-1.8612.369-3.6174 1.036-5.2197 1.001-2.4044 2.68-4.4579 4.791-5.9052 2.112-1.4463 4.637-2.2869 7.384-2.2881 2.902.0012 5.562.9408 7.744 2.5433l3.482-4.88c-3.148-2.3207-7.042-3.6925-11.226-3.6917-2.636 0-5.162.5444-7.455 1.5294-3.44 1.4774-6.357 3.939-8.423 7.0398-2.064 3.0989-3.272 6.8561-3.27 10.8722 0 .0663.005.1338.005.2008h-.104c0 1.8592-.369 3.6167-1.037 5.219-1.002 2.4026-2.679 4.4574-4.788 5.904-2.113 1.4462-4.639 2.2876-7.384 2.2892-1.834-.0011-3.563-.3755-5.142-1.0538-2.367-1.015-4.39-2.7198-5.816-4.8622-.666-1.0042-1.202-2.1024-1.584-3.2711-.245-.1221-.511-.2595-.792-.4116-1.353-.7357-3.049-1.8093-4.439-3.2184-.583-.5919-1.105-1.1765-1.574-1.7423.031.3772.049.7595.049 1.1472 0 1.8592-.368 3.6167-1.037 5.219-1 2.4026-2.679 4.4574-4.789 5.904-2.1122 1.4462-4.6385 2.2876-7.3837 2.2892-1.8329-.0011-3.5628-.3755-5.142-1.0538-2.3669-1.015-4.3894-2.7198-5.8142-4.8622-1.4254-2.1444-2.254-4.7096-2.2546-7.4962 0-1.8602.3696-3.6178 1.0368-5.2208 1-2.4029 2.6794-4.4564 4.7891-5.9037 2.1125-1.4463 4.6376-2.2881 7.3849-2.2887 1.8315 0 3.5619.3758 5.141 1.053 2.3667 1.016 4.3897 2.7202 5.8147 4.8622.032.0488.062.098.094.1475l.009-.0035v.0043l.009.0221c.001.0034.004.0091.005.0139.055.0855.106.1747.159.2607.133.3041.399.8806.818 1.6328.042.0752.087.1544.133.2337.034.0835.072.1649.105.2489.389.6444.885 1.3851 1.498 2.1792.034.0438.064.0863.098.1295.536.6996 1.166 1.4293 1.887 2.1447.005.0053.009.0094.013.0134.006.006.012.0106.017.0166.114.1134.23.2248.349.3365.047.0429.093.0861.14.1287.756.6969 1.603 1.3708 2.564 1.9762 1.079.681 2.296 1.2723 3.642 1.6975 1.347.4264 2.824.6847 4.403.7092h.002c.136.0023.269.0037.402.0037 2.544.0006 4.826-.4032 6.829-1.1224 1.503-.5384 2.846-1.2516 4.024-2.0778 1.768-1.2416 3.162-2.7299 4.249-4.255 1.087-1.5281 1.869-3.0941 2.44-4.5394.436-1.1063.66-2.2054.66-3.2578 0-.6056-.073-1.1902-.211-1.735-.238-.954-.665-1.769-1.14-2.4102-.717-.9662-1.52-1.5682-2.144-1.9589-.63-.3887-1.1-.5684-1.24-.6197l-.01.034c-2.502-1.214-5.306-1.8967-8.252-1.8962-2.636-.0005-5.163.5431-7.455 1.5286-2.244.9645-4.264 2.3481-5.972 4.0541v-18.6693734h-5.936v16.2618734c.363.3526.739.735 1.131 1.1524 1.501 1.6028 2.474 3.1516 3.328 4.5762.855 1.4285 1.594 2.723 2.632 3.9046.157.181.325.359.499.5358 1.02-2.0258 2.539-3.7595 4.388-5.0279 2.111-1.4463 4.638-2.2881 7.385-2.2887 2.408.0006 4.644.6475 6.586 1.7832l.023-.0417c.127.1008.243.2175.308.3177.048.0708.079.132.101.2026.022.0704.042.1526.042.2966 0 .1932-.038.5135-.236 1.0188-.373.9467-.866 1.9454-1.497 2.8936-.473.7112-1.024 1.3951-1.659 2.018-.957.935-2.099 1.7378-3.532 2.3264-1.432.5875-3.167.9667-5.341.9672-.102 0-.203-.0005-.305-.002h-.001c-.898-.0154-1.707-.1434-2.458-.3546-1.31-.3698-2.448-.999-3.448-1.7722-.349-.2698-.679-.5596-.991-.859 0-.0015 0-.0052.002-.008-.15-.1403-.293-.2823-.434-.4238-.82-.8593-1.491-1.7684-1.983-2.5513-.376-.5959-.762-1.0924-.937-1.4456-.087-.1775-.261-.4527-.261-.4527-.888-1.487-1.811-2.9982-3.286-4.5744-.019-.0209-.039-.0381-.056-.0592v.0011c-.758-.7263-1.571-1.3931-2.438-1.9873-3.052-2.095-6.7519-3.3226-10.7067-3.321-2.6361-.0005-5.1614.5431-7.4548 1.5286-3.44 1.4782-6.3577 3.9396-8.4218 7.04-2.0638 3.0988-3.2728 6.8554-3.2716 10.8722-.0012 2.6754.5352 5.2404 1.5056 7.5672 1.4554 3.4932 3.8796 6.4548 6.9342 8.5506 3.0523 2.0964 6.7522 3.3232 10.7084 3.3225 2.6351.0003 5.1616-.5443 7.4537-1.5299 3.44-1.4777 6.357-3.9386 8.422-7.0392.13-.1957.256-.3926.379-.5934 1.426 2.3209 3.317 4.3114 5.543 5.84 3.053 2.0964 6.753 3.3232 10.71 3.3225 2.634.0003 5.16-.5443 7.453-1.5299 3.437-1.4777 6.357-3.9386 8.42-7.0392.144-.2148.283-.4332.416-.6554 1.417 2.2609 3.275 4.2034 5.46 5.7012 3.052 2.0957 6.751 3.3225 10.707 3.3221 2.633.0004 5.162-.5437 7.453-1.5291 2.144-.9201 4.083-2.2226 5.74-3.8234v5.4274h5.937v-12.7342l2.228-2.6848 12.19 15.419h7.613zm-6.126-31.7228734h-5.937v32.2332734c0 .8744-.084 1.725-.243 2.5496l6.18-7.4916z",
    fill: "#252f3f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m34.0189 13.86v15.7973c0 7.3592-4.4501 11.8042-11.1961 11.8042-6.7467 0-11.4829-4.445-11.4829-11.8042v-29.6573h-11.3399v29.6573c0 13.4804 8.89879 21.8604 22.8228 21.8604 13.8515 0 22.5361-8.38 22.5361-21.8604v-29.6573h-.1992c-5.9802 1.94948-10.4416 7.32973-11.1408 13.86z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m55.0664 0h-.1948v51.0084h11.3401v-37.1381c-.1071-5.66845-5.1616-11.91957-11.1453-13.8703z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m34.0188 13.86v15.7973c0 .0095-.0007.019-.0007.0295.0027.1571.0111.3129.0111.4712 0 10.6391-7.8921 19.4019-18.0551 20.5959 2.1151.5002 4.4028.7638 6.8486.7638 13.8514 0 22.5361-8.38 22.5361-21.8604v-29.6573h-.1992c-5.9803 1.94948-10.4416 7.32973-11.1408 13.86z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m11.3399 13.8856v-13.8856h-11.3399v.00225067c6.02904 1.95298933 10.5469 7.33198933 11.3399 13.88334933z",
    fill: "url(#d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m54.8716 35.8926v15.1157h11.2017c-6.2467-2.238-10.8021-8.1097-11.2017-15.1157z",
    fill: "url(#e)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUideck);
export default __webpack_public_path__ + "static/media/uideck.0ad6abaef85731b4994085e500724af1.svg";
export { ForwardRef as ReactComponent };